import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {Button, Form, Row, Col, Container} from "react-bootstrap";
import addIcon from "../../styles/assets/icons/add.svg";
import ArticleModal from "./ArticleModal";
import ArticlesTable from "./ArticlesTable";
import {fetchPromises} from "../../core/utils/fetchPromises.js";
import queryString from "query-string";
import {ENUM} from "../../core/utils/enum.js";
import { MultiSelect } from "react-multi-select-component";

function ArticlesPage({ location, history, brands, categories }) {
    const filter = queryString.parse(location.search, { arrayFormat: "comma" });
    const [brandFilter, setBrandFilter] = useState(brands
        .filter(b => Array.isArray(filter.brand) ? filter.brand.includes(String(b.id)) : String(b.id) === filter.brand)
        .map(b => ({label: b.name, value: b.id})));
    const [categoryFilter, setCategoryFilter] = useState(categories
        .filter(c => Array.isArray(filter.category) ? filter.category.includes(String(c.id)) : String(c.id) === filter.category)
        .map(c => ({label: c.name, value: c.id})));
    const [modal, setModal] = useState({
        show: false
    });

    const onEditClick = async (event) => {
        setModal({
            show: true,
            articleId: +event.currentTarget.dataset.id
        });
    }

    const onArticleFilterChange = (event) => {
        history.push({
            pathname: `/${ENUM.route.admin}/${ENUM.route.articles}`,
            search: "?" + queryString.stringify({
                ...filter,
                articleName: event.target.value !== "" ? event.target.value : undefined,
            })
        });
    }

    const onBrandFilterChange = (brand) => {
        history.push({
            pathname: `/${ENUM.route.admin}/${ENUM.route.articles}`,
            search: "?" + queryString.stringify({
                ...filter,
                brand: brand.map(b => b.value),
            }, { arrayFormat: "comma" })
        });
        setBrandFilter(brand);
    }

    const onCategoryFilterChange = (category) => {
        history.push({
            pathname: `/${ENUM.route.admin}/${ENUM.route.articles}`,
            search: "?" + queryString.stringify({
                ...filter,
                category: category.map(c => c.value)
            },{ arrayFormat: "comma" })
        });
        setCategoryFilter(category);
    }

    return (
        <div className="w-100 d-flex flex-column">
            <div className="page-header w-100 d-flex justify-content-between align-items-center">
                <div className="page-header-title d-flex align-items-center p-2">
                    <Container fluid>
                        <Row className="align-items-center">
                            <Col>
                                <Form.Control
                                    type="text"
                                    name="articleName"
                                    value={filter.articleName || ''}
                                    onChange={onArticleFilterChange}
                                    placeholder="Article name"
                                />
                            </Col>
                            <Col>
                                <MultiSelect
                                    options={brands.map((c) => ({ label: c.name, value: c.id }))}
                                    value={brandFilter}
                                    onChange={onBrandFilterChange}
                                    labelledBy="Brand"
                                    overrideStrings={{
                                        selectSomeItems: "Brand",
                                    }}
                                />
                            </Col>
                            <Col>
                                <MultiSelect
                                    options={categories.map((c) => ({ label: c.name, value: c.id }))}
                                    value={categoryFilter}
                                    onChange={onCategoryFilterChange}
                                    labelledBy="Category"
                                    overrideStrings={{
                                        selectSomeItems: "Category",
                                    }}
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="page-header-actions">
                    <Button variant="outline-primary" className="d-flex align-items-center" size="sm" onClick={onEditClick}>
                        <img className="me-1" src={addIcon} alt="add" />
                        <span>Add</span>
                    </Button>
                </div>
            </div>
            <ArticlesTable 
                onEditClick={onEditClick} 
                filter={filter}
            />
            {modal.show &&
                <ArticleModal
                    articleId={modal.articleId}
                    setModal={setModal}
                />
            }
        </div>
    );
}
export default withRouter(
    fetchPromises({
        brands: () => ({ name: 'getBrands' }),
        categories: () => ({ name: 'getCategories' }),
    })(ArticlesPage)
);
